import { createI18n } from 'vue-i18n'

import dateTimeFormats from '@/i18n/dateTimeFormats.js'
import numberFormats from '@/i18n/numberFormats.js'

// Load all locales and remember context
function loadMessages() {
  const files = import.meta.glob('@/locales/**/*.json', { eager: true })
  const messages = {}

  for (const path in files) {
    const matched = path.match(/\/locales\/(.*)\.json$/)
    if (!matched) continue

    const levels = matched[1].split('/')
    let prevLevel = messages
    let prevProp = levels.shift()

    levels.forEach(prop => {
      prevLevel[prevProp] = prevLevel[prevProp] || {}
      prevLevel = prevLevel[prevProp]
      prevProp = prop
    })

    prevLevel[prevProp] = prevLevel[prevProp] || {}
    prevLevel[prevProp] = files[path].default
  }

  return messages
}

// VueI18n instance
const i18n = createI18n({
  locale: localStorage.getItem('language') || import.meta.env.VITE_I18N_LOCALE || 'tr',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || 'en',
  warnHtmlMessage: false, //@TODO: use instead https://kazupon.github.io/vue-i18n/guide/interpolation.html#basic-usage
  messages: loadMessages(),
  dateTimeFormats,
  numberFormats
})

export default i18n
